/** Strip HTML tags, URLs and entities, collapse whitespace — port of ConversationSelectionModal.cleanText (Vue). */
export function cleanText(text: string): string {
  return text
    .replace(/<[^>]*>/g, "") // strip HTML tags
    .replace(/https?:\/\/\S+/g, "") // strip URLs
    .replace(/&\w+;/g, " ") // strip HTML entities
    .replace(/\s{2,}/g, " ") // collapse whitespace
    .trim();
}

/** Clean then truncate to `max` characters — port of ConversationSelectionModal.truncate (Vue). */
export function truncate(text: string, max = 240): string {
  const cleaned = cleanText(text || "");

  if (!cleaned || cleaned.length <= max) {
    return cleaned;
  }
  return `${cleaned.slice(0, max)}...`;
}
